import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cssStyles from './Popover.css';

const noop = () => {};
class Popover extends Component {
  static propTypes = {
    open: PropTypes.bool,
    popOverContent: PropTypes.element,
    children: PropTypes.element,
    onClick: PropTypes.func,
    onBlur: PropTypes.func,
    position: PropTypes.string,
    heightDifference: PropTypes.number,
    widthDifference: PropTypes.number,
    popOverClass: PropTypes.string,
  };

  static defaultProps = {
    open: false,
    popOverContent: <div />,
    children: <div />,
    onClick: () => {},
    onBlur: () => {},
    position: 'bottom-right',
    popOverClass: '',
    heightDifference: 0,
    widthDifference: 0,
  };

  constructor() {
    super();

    this.el = React.createRef();
    this.mask = React.createRef();
    this.popover = React.createRef();
  }

  componentDidMount() {
    const { open } = this.props;
    if (open && !this.popover.current.contains(document.activeElement)) {
      this.popover.current.focus();
    }
  }

  componentDidUpdate() {
    const { open } = this.props;
    if (open && !this.popover.current.contains(document.activeElement)) {
      this.popover.current.focus();
    }
  }

  onClick = event => {
    const { onClick } = this.props;
    if (onClick) {
      onClick(event);
    }
  };

  onBlur = event => {
    const target = event.currentTarget;
    event.persist();
    setTimeout(() => {
      if (target.contains(document.activeElement)) {
        return;
      }
      const { onBlur } = this.props;
      if (onBlur) {
        onBlur(event);
      }
    }, 0);
  };

  getPositionStyle() {
    const { position, heightDifference, widthDifference } = this.props;

    if (!this.el.current) {
      return {};
    }

    const elRects = this.el.current.getBoundingClientRect();

    const elHeight = elRects.height + heightDifference;
    const elWidth = elRects.width + widthDifference;

    switch (position) {
      case 'top-left': {
        return {
          bottom: `${elRects.bottom + elHeight}px`,
          right: `${elRects.right + elWidth}px`,
        };
      }
      case 'top-right': {
        return {
          bottom: `${elRects.bottom + elHeight}px`,
          left: `${elRects.left + elWidth}px`,
        };
      }
      case 'bottom-left': {
        return {
          top: `${elRects.top + elHeight}px`,
          right: `${elRects.left}px`,
        };
      }
      case 'bottom-right':
      default: {
        return {
          top: `${elRects.top + elHeight}px`,
          left: `${elRects.left + elWidth}px`,
        };
      }
    }
  }

  getPopover() {
    const { popOverContent, popOverClass } = this.props;

    return ReactDOM.createPortal(
      <React.Fragment>
        <div
          ref={this.popover}
          className={`${cssStyles.popover_body} ${popOverClass}`}
          style={this.getPositionStyle()}
          onBlur={this.onBlur}
          tabIndex='-1'
          role='presentation'
        >
          {popOverContent}
        </div>
      </React.Fragment>,
      document.body
    );
  }

  render() {
    const { children, open } = this.props;

    return (
      <React.Fragment>
        <span
          ref={this.el}
          className={cssStyles.popover_trigger}
          onClick={this.onClick}
          onKeyUp={noop}
          role='button'
          tabIndex='-1'
        >
          {children}
        </span>
        {open ? this.getPopover() : null}
      </React.Fragment>
    );
  }
}

export default Popover;



// WEBPACK FOOTER //
// ./src/components/common/Popover/Popover.js